import { render, staticRenderFns } from "./MainProjectItem.vue?vue&type=template&id=7f86a7e0&scoped=true&"
import script from "./MainProjectItem.vue?vue&type=script&lang=js&"
export * from "./MainProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./MainProjectItem.vue?vue&type=style&index=0&id=7f86a7e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f86a7e0",
  null
  
)

export default component.exports